import type React from 'react';

import { observer } from 'mobx-react';

import AddControl from '../../../controls/add-control';
import NestedPage from '../../../controls/nested-page';
import {
  MenuPageContext,
  MenuPageItemContext,
  ParentMenuPageContext,
  useMenuPage,
  useMenuStore
} from '../../../stores/menu-store';

export interface IProps {
  onAdd?: () => void;
  onBlur?: () => void;
}

const NestedListList: React.FC<IProps> = observer(({ onAdd, onBlur }) => {
  const menu = useMenuStore();
  const page = useMenuPage();

  const { items, order } = page!;

  const content = order.map((key) => {
    const item = items.get(key)!;

    return (
      <MenuPageContext.Provider key={key} value={menu!.pages.get(key)!}>
        <MenuPageItemContext.Provider value={item}>
          <NestedPage route={key} />
        </MenuPageItemContext.Provider>
      </MenuPageContext.Provider>
    );
  });

  return (
    <ParentMenuPageContext.Provider value={page}>
      <>
        {content}
        <AddControl route={page.route} onAdd={onAdd} onBlur={onBlur} />
      </>
    </ParentMenuPageContext.Provider>
  );
});

NestedListList.displayName = 'NestedListList';

export default NestedListList;
